import React from 'react';
import { Route, Routes, Outlet } from 'react-router-dom';
import { SubscriptionProvider } from './context/SubscriptionContext';
import Dashboard from './pages/Dashboard';
import Editor from './pages/Editor';
import FinishSignUp from './pages/FinishSignUp';
import JobInterview from './pages/JobInterview';
import Jobs from './pages/Jobs';
import Login from './pages/Login';
import MyAccount from './pages/MyAccount';
import Plans from './pages/Plans';
import ResumeAnalysis from './pages/ResumeAnalysis';
import Resumes from './pages/Resumes';
import Sample from './pages/Sample';
import Signup from './pages/Signup';
import Support from './pages/Support';
import VerifyEmail from './pages/VerifyEmail';
import Layout from './components/Layout';
import Admin from './pages/Admin'; // Import the new Admin component
import c from './pages/Admin/SwitchUser'; 
import ExampleRedirect from './components/ExampleRedirect';
import CLExampleRedirect from './components/CLExampleRedirect';
import CvExampleNew from './pages/CvExampleNew';
import CLExampleNew from './pages/CLExampleNew';
import ContactForm from './pages/Contact';
import ResumeUploadAndCreate from './pages/ResumeUploadAndCreate';
import OptmizeResumeWithAI from './pages/OptimizeResumeWithAI';
import OptimizeLinkedInProfile from './pages/OptimizeLinkedInProfile';
import JobTracker from './components/Job/JobTracker'; 
import EmailGenerator from './pages/emailGenerator';
import AddSectionForm from './components/AddSectionForm';
import Assessment from './components/Assessment';
import CancelPage from './pages/CancelPage';
import SuccessPage from './pages/SuccessPage';
import SwitchUser from './pages/Admin/SwitchUser';

const LayoutRoute = () => (
  <Layout>
    <Outlet />
  </Layout>
);

function App() {
  return (
    <SubscriptionProvider>
    <Routes>
      {/* Routes without Layout */}
      <Route path="/editor/resume/:resumeid" element={<Editor />} />
      <Route path="/editor/cover-letter/:coverLetterId" element={<Editor />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/example" element={<ExampleRedirect />} /> 
      <Route path="/cl-example" element={<CLExampleRedirect />} /> 

      {/* Routes with Layout */}
      <Route element={<LayoutRoute />}>
        <Route path="/documents" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cvexample" element={<CvExampleNew />} />
        <Route path="/clexample" element={<CLExampleNew />} />
        <Route path="/finish-sign-up" element={<FinishSignUp />} />
        <Route path="/job-interview" element={<JobInterview />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/job-tracker" element={<JobTracker />} />
        <Route path="/admin" element={<Admin />} /> {/* Admin route with Layout */}
        <Route path="/switch-user" element={<SwitchUser />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/plans" element={<Plans />} /> 
        <Route path="/success" element={<SuccessPage/>} /> 
        <Route path="/cancel" element={<CancelPage />} /> 
        <Route path="/resume-analysis" element={<ResumeAnalysis />} />
        <Route path="/resumes" element={<Resumes />} />
        <Route path="/sample" element={<Sample />} />
        <Route path="/optimize-resume" element={<OptmizeResumeWithAI/>} />
        <Route path="/optimize-linkedin-profile" element={<OptimizeLinkedInProfile/>} />
        <Route path="/uploadresume" element={<ResumeUploadAndCreate/>} />
        <Route path="/support" element={<Support />} />
        <Route path="/email-generator" element={<EmailGenerator />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/addsections" element={<AddSectionForm />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/" element={<Dashboard />} /> {/* Default route */}
      </Route>
    </Routes>
    </SubscriptionProvider>
  );
}

export default App;